module.exports = __webpack_public_path__ + "static/World-37529a5ac7b0c860e8ab96acf7709202.png";